/**
 * Telephony Support (UST-3132) — INBOUND support calls answered by a voice AI.
 *
 * Deliberately separate from the Sales voice agent (`types/voice-agent.ts`),
 * which places OUTBOUND calls: different credentials, different agent, and a
 * settings mistake on one must never silence the other. What the two DO share
 * is the ticketing system — a call that raises a ticket raises the same ticket
 * every other channel uses.
 *
 * Call records also stay out of the Support Inbox on purpose: the inbox is for
 * written threads, and a call transcript read as a chat thread is noise.
 */
/** Providers that can answer an inbound support line. */
export const TELEPHONY_PROVIDERS = [
    'elevenlabs',
    'vapi',
    'retell',
    'nabrah',
    'voiceinfra',
];
export const TELEPHONY_PROVIDER_LABELS = {
    elevenlabs: 'ElevenLabs',
    vapi: 'Vapi',
    retell: 'Retell.ai',
    nabrah: 'Nabrah',
    voiceinfra: 'VoiceInfra',
};
/**
 * Lifecycle of one inbound call.
 *
 *   ringing → in_progress → ended → analyzed
 *
 * `analyzed` is terminal: transcript and summary arrive after the call ends,
 * sometimes minutes later. `failed` is any call the provider reported as not
 * connected.
 */
export const TELEPHONY_CALL_STATUSES = [
    'ringing',
    'in_progress',
    'ended',
    'analyzed',
    'failed',
];
/**
 * How the caller was matched to someone we already know.
 *
 * UST-3147 added `email` and `handle`: the customer card holds a column per
 * contact point, so a caller who gives an address can be identified by it.
 */
export const TELEPHONY_CALLER_MATCHES = ['phone', 'name', 'email', 'handle', 'none'];
/**
 * Settings → Telephony support → Danger zone: deleting the whole call history
 * needs this phrase typed exactly, in the popup and again by the API.
 */
export const TELEPHONY_CALLS_DELETE_ALL_PHRASE = 'delete-telephony-calls';
//# sourceMappingURL=telephony-support.js.map